var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { customElement, property, query, state } from 'lit/decorators.js';
import styles from './share-dialog.styles';
import { dictionary } from '@mf-cms/helpers';
import { MFElement } from '../mfelement/mfelement';
let PShareDialog = class PShareDialog extends MFElement {
    constructor() {
        super(...arguments);
        this.culture = 'en-GB';
        this.mediaType = 'video';
        this.embedCode = '';
        this.embedType = 'js';
        this.playerOptions = {};
        this.locale = '';
        this.nativeLang = '';
    }
    static { this.styles = styles; }
    /**
     * Open dialog
     * @returns {void}
     */
    open() {
        this.onOpenDialog();
    }
    /**
     * Close dialog
     * @returns {void}
     */
    close() {
        this.dialog.close();
    }
    /**
     * On open dialog
     * @returns {void}
     */
    async onOpenDialog() {
        if (this.allowEmbed) {
            await this.generateEmbedCode();
        }
        this.dialog.open();
    }
    /**
     * Copy video link
     * @param {CustomEvent} e - Event
     * @returns {void}
     */
    copyLink(e) {
        const button = e.target;
        navigator.clipboard.writeText(this.url);
        button.success();
    }
    /**
     * Copy video link
     * @param {CustomEvent} e - Event
     * @returns {void}
     */
    copyEmbedCode(e) {
        const button = e.target;
        navigator.clipboard.writeText(this.embedCode);
        button.success();
    }
    /**
     * Update embed type (iframe or js)
     * @param {Event} e - Event
     * @returns {void}
     */
    updateEmbedType(e) {
        this.embedType = e.target.value;
        this.generateEmbedCode();
    }
    /**
     * Generate embed code
     * @returns {void}
     */
    async generateEmbedCode() {
        const requestUrl = `${process.env.MEDIA_API_URL}/embed`;
        if (this.embedType === 'js') {
            if (process.env.VIDEO_PLAYER_ENV != 'production') {
                this.playerOptions['env'] = process.env.VIDEO_PLAYER_ENV
                    ? process.env.VIDEO_PLAYER_ENV
                    : '';
            }
        }
        if (this.playerTheme) {
            this.playerOptions['theme'] = this.playerTheme;
        }
        let optionStringJS = '';
        if (this.embedType == 'js') {
            optionStringJS = JSON.stringify(this.playerOptions);
        }
        const postData = {
            embedType: this.embedType == 'js' ? 'js' : 'iframe-responsive',
            mediaType: 'video',
            options: this.embedType == 'js' ? optionStringJS : '',
            videoId: this.mediaId,
            mediaTitle: this.mediaTitle
        };
        if (this.playerTheme && this.embedType == 'iframe') {
            postData.themeId = this.playerTheme;
        }
        const response = await fetch(requestUrl, {
            method: 'POST',
            body: JSON.stringify(postData)
        });
        const data = await response.json();
        if (response.status !== 200) {
            return '';
        }
        this.embedCode = data.embedCode;
    }
    renderLinkSection() {
        if (!this.url)
            return '';
        return html ` <div class="copy-wrap"> <p-input input-id="input-share-link" readonly label=${dictionary(this.culture, 'shareDialog', 'videoLink')} value=${this.url} ></p-input> <p-button color="border" label=${dictionary(this.culture, 'shareDialog', 'copyLink')} title=${dictionary(this.culture, 'shareDialog', 'copyLink')} icon @p-click=${this.copyLink} > ${this.renderCopyIcon()} </p-button> </div> `;
    }
    renderEmbedSection() {
        if (!this.allowEmbed)
            return '';
        return html ` ${this.url ? html `<hr />` : ''}
      <fieldset class="embed-type">
        <legend class="label">
          ${dictionary(this.culture, 'shareDialog', 'embedCode')}
        </legend>
        <div class="embed-type-options">
          <label class="embed-type-option">
            <input
              type="radio"
              name="embed-type"
              value="js"
              .checked=${this.embedType === 'js'}
              @change=${this.updateEmbedType}
            />
            <span>JavaScript</span>
          </label>
          <label class="embed-type-option">
            <input
              type="radio"
              name="embed-type"
              value="iframe"
              .checked=${this.embedType === 'iframe'}
              @change=${this.updateEmbedType}
            />
            <span>Iframe</span>
          </label>
        </div>
      </fieldset>
      <div class="code-preview">
        <pre><code>${this.embedCode}</code></pre>
        <p-button
          dark
          class="copy-code-button"
          color="border"
          label=${dictionary(this.culture, 'shareDialog', 'copyEmbedCode')}
          title=${dictionary(this.culture, 'shareDialog', 'copyEmbedCode')}
          icon
          @p-click=${this.copyEmbedCode}
        >
          ${this.renderCopyIcon()}
        </p-button>
      </div>
    `;
    }
    renderCopyIcon() {
        return html ` <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" > <path fill-rule="evenodd" d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z" /> </svg> `;
    }
    renderSocialSection() {
        if (!this.allowSocial)
            return '';
        return html ` <hr /> <h3 class="label" id="share-on-social-media"> ${dictionary(this.culture, 'shareDialog', 'shareOnSocialMedia')} </h3> <ul class="inline-list" aria-labelledby="share-on-social-media"> <li> <p-button icon class="share-social" href=${`https://www.facebook.com/sharer/sharer.php?u=${this.url}`}
            target="_blank"
            color="border"
            label=${dictionary(this.culture, 'shareDialog', 'shareFacebook')}
          >
            <svg
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              viewBox="0 0 16 16"
            >
              <path
                d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951"
              ></path>
            </svg>
          </p-button>
        </li>
        <li>
          <p-button
            icon
            class="share-social"
            href=${`https://twitter.com/intent/tweet?url=${this.url}`}
            target="_blank"
            color="border"
            label=${dictionary(this.culture, 'shareDialog', 'shareX')}
          >
            <svg
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              viewBox="0 0 16 16"
            >
              <path
                d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"
              ></path>
            </svg>
          </p-button>
        </li>
        <li>
          <p-button
            icon
            class="share-social"
            href=${`https://www.linkedin.com/shareArticle?url=${this.url}`}
            target="_blank"
            color="border"
            label=${dictionary(this.culture, 'shareDialog', 'shareLinkedIn')}
          >
            <svg
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              viewBox="0 0 16 16"
            >
              <path
                d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854zm4.943 12.248V6.169H2.542v7.225zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248S2.4 3.226 2.4 3.934c0 .694.521 1.248 1.327 1.248zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016l.016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225z"
              ></path>
            </svg>
          </p-button>
        </li>
        <li>
          <p-button
            icon
            class="share-social"
            href=${`https://pinterest.com/pin/create/button/?url=${this.url}`}
            target="_blank"
            color="border"
            label=${dictionary(this.culture, 'shareDialog', 'sharePinterest')}
          >
            <svg
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              viewBox="0 0 16 16"
            >
              <path
                d="M8 0a8 8 0 0 0-2.915 15.452c-.07-.633-.134-1.606.027-2.297.146-.625.938-3.977.938-3.977s-.239-.479-.239-1.187c0-1.113.645-1.943 1.448-1.943.682 0 1.012.512 1.012 1.127 0 .686-.437 1.712-.663 2.663-.188.796.4 1.446 1.185 1.446 1.422 0 2.515-1.5 2.515-3.664 0-1.915-1.377-3.254-3.342-3.254-2.276 0-3.612 1.707-3.612 3.471 0 .688.265 1.425.595 1.826a.24.24 0 0 1 .056.23c-.061.252-.196.796-.222.907-.035.146-.116.177-.268.107-1-.465-1.624-1.926-1.624-3.1 0-2.523 1.834-4.84 5.286-4.84 2.775 0 4.932 1.977 4.932 4.62 0 2.757-1.739 4.976-4.151 4.976-.811 0-1.573-.421-1.834-.919l-.498 1.902c-.181.695-.669 1.566-.995 2.097A8 8 0 1 0 8 0"
              />
            </svg>
          </p-button>
        </li>
      </ul>
    `;
    }
    /**
     * Render component
     * @returns {TemplateResult} Template
     */
    render() {
        return html ` <p-dialog heading=${dictionary(this.culture, 'shareDialog', 'shareVideo')} dialog-id="share-dialog" culture=${this.culture} > ${this.renderLinkSection()} ${this.renderEmbedSection()} ${this.renderSocialSection()} <p-button color="border" slot="footer" @p-click=${this.close}> ${dictionary(this.culture, 'general', 'close')} </p-button> </p-dialog> `;
    }
};
__decorate([
    property({ type: String })
], PShareDialog.prototype, "culture", void 0);
__decorate([
    property({ type: String })
], PShareDialog.prototype, "url", void 0);
__decorate([
    property({ type: String, attribute: 'media-id', reflect: true })
], PShareDialog.prototype, "mediaId", void 0);
__decorate([
    property({ type: Number, attribute: 'media-height' })
], PShareDialog.prototype, "mediaHeight", void 0);
__decorate([
    property({ type: Number, attribute: 'media-width' })
], PShareDialog.prototype, "mediaWidth", void 0);
__decorate([
    property({ type: String, attribute: 'media-title' })
], PShareDialog.prototype, "mediaTitle", void 0);
__decorate([
    property({ type: String, attribute: 'media-type' })
], PShareDialog.prototype, "mediaType", void 0);
__decorate([
    property({ type: Boolean, attribute: 'allow-embed' })
], PShareDialog.prototype, "allowEmbed", void 0);
__decorate([
    property({ type: Boolean, attribute: 'allow-social' })
], PShareDialog.prototype, "allowSocial", void 0);
__decorate([
    property({ type: String, attribute: 'player-theme' })
], PShareDialog.prototype, "playerTheme", void 0);
__decorate([
    query('p-dialog')
], PShareDialog.prototype, "dialog", void 0);
__decorate([
    state()
], PShareDialog.prototype, "embedCode", void 0);
__decorate([
    state()
], PShareDialog.prototype, "embedType", void 0);
PShareDialog = __decorate([
    customElement('p-share-dialog')
    /**
     * PShareDialog component
     *
     * @class PShareDialog
     * @typedef {PShareDialog}
     * @extends {LitElement}
     */
], PShareDialog);
export { PShareDialog };
